import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useSportContent } from '../hooks/useSportContent';

const StrategiesScreen: React.FC = () => {
  const { currentSport } = useTheme();
  const { content, loading, error } = useSportContent(currentSport.id);

  if (loading) {
    return (
      <div className="strategies-screen">
        <div className="container">
          <h1>Loading {currentSport.name} Strategies...</h1>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="strategies-screen">
        <div className="container">
          <h1>Error Loading Strategies</h1>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="strategies-screen">
      <div className="container">
        <h1>{currentSport.name} Strategies</h1>
        <div className="strategies-grid">
          {content?.strategies.map((strategy) => (
            <div key={strategy.id} className="strategy-card">
              <h3>{strategy.title}</h3>
              <p>{strategy.description}</p>
              <div className="strategy-meta">
                <span className="difficulty">{strategy.difficulty}</span>
                <span className="category">{strategy.category}</span>
              </div>
              <div className="strategy-tips">
                <strong>Key Tips:</strong>
                <ul>
                  {strategy.tips.map((tip, index) => (
                    <li key={index}>{tip}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StrategiesScreen;
